import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  UsersIcon,
  ShoppingBagIcon,
  TruckIcon,
  CurrencyDollarIcon,
  ChartBarIcon,
  CogIcon,
  DocumentTextIcon,  // Changed from DocumentReportIcon
  ArchiveBoxIcon,     // Changed from ArchiveIcon
  CreditCardIcon,
  BellIcon,
  UserCircleIcon,
  BuildingOfficeIcon,
  ArrowPathIcon,
  ShoppingCartIcon
} from '@heroicons/react/24/outline';

const Sidebar = ({ user, onClose }) => {
  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, roles: ['owner', 'manager', 'sales_agent', 'shop_owner'] },
    { name: 'Users', href: '/users', icon: UsersIcon, roles: ['owner', 'manager'] },
    { name: 'Depots', href: '/depots', icon: BuildingOfficeIcon, roles: ['owner', 'manager'] },
    { name: 'Transfers', href: '/transfers', icon: ArrowPathIcon, roles: ['owner', 'manager', 'sales_agent'] },
    { name: 'Orders', href: '/orders', icon: ShoppingCartIcon, roles: ['owner', 'manager', 'sales_agent', 'shop_owner'] },
    { name: 'Shop Owners', href: '/shop-owners', icon: ShoppingBagIcon, roles: ['owner', 'manager', 'sales_agent'] },
    { name: 'Consignments', href: '/consignments', icon: TruckIcon, roles: ['owner', 'manager', 'sales_agent'] },
    { name: 'Sales', href: '/sales', icon: CurrencyDollarIcon, roles: ['owner', 'manager', 'sales_agent', 'shop_owner'] },
    { name: 'Payments', href: '/payments', icon: CreditCardIcon, roles: ['owner', 'manager', 'sales_agent', 'shop_owner'] },
    { name: 'Inventory', href: '/inventory', icon: ArchiveBoxIcon, roles: ['owner', 'manager'] },
    { name: 'Expenses', href: '/expenses', icon: DocumentTextIcon, roles: ['owner', 'manager', 'sales_agent'] },
    { name: 'Reports', href: '/reports', icon: ChartBarIcon, roles: ['owner', 'manager'] },
    { name: 'Notifications', href: '/notifications', icon: BellIcon, roles: ['owner', 'manager', 'sales_agent', 'shop_owner'] },
    { name: 'Profile', href: '/profile', icon: UserCircleIcon, roles: ['owner', 'manager', 'sales_agent', 'shop_owner'] },
    { name: 'Settings', href: '/settings', icon: CogIcon, roles: ['owner'] },
  ];

  const filteredNavigation = navigation.filter(item => 
    item.roles.includes(user?.user_type)
  );

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-center h-16 px-4 bg-primary-600">
        <h1 className="text-xl font-bold text-white">BevDist</h1>
      </div>
      
      <div className="flex-1 flex flex-col overflow-y-auto bg-primary-700">
        <nav className="flex-1 px-2 py-4 space-y-1">
          {filteredNavigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              onClick={onClose}
              className={({ isActive }) =>
                `group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors duration-150 ${
                  isActive
                    ? 'bg-primary-800 text-white'
                    : 'text-primary-100 hover:bg-primary-600 hover:text-white'
                }`
              }
            >
              <item.icon
                className="mr-3 flex-shrink-0 h-6 w-6 text-primary-300 group-hover:text-white transition-colors duration-150"
                aria-hidden="true"
              />
              {item.name}
            </NavLink>
          ))}
        </nav>

        {/* User info at bottom */}
        <div className="flex-shrink-0 flex border-t border-primary-800 p-4">
          <div className="flex items-center">
            <div>
              <p className="text-sm font-medium text-white">
                {user?.first_name} {user?.last_name}
              </p>
              <p className="text-xs font-medium text-primary-200 capitalize">
                {user?.user_type?.replace('_', ' ')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;